<template>
  <div
    class="toggle"
    :data-type="form"
    :data-arrow="arrow"
  >
    <button
      v-for="item in list"
      :key="item.key"
      class="item"
      :data-selected="selected === item.key"
      @click="selected = item.key"
    >
      <p class="text">
        {{ item.text }}
      </p>
    </button>
  </div>
</template>

<script setup>
defineProps({
  /**
   * @type {Array<{ text: string, key: string }>}
   */
  list: {
    type: Array,
    required: true
  },
  form: {
    type: String,
    default: 'square'
  },
  arrow: {
    type: Boolean,
    default: false
  }
})

const selected = defineModel('selected', { type: String, required: true })
</script>

<style lang="scss" scoped>
.toggle {
  display: flex;
  padding: 5px;
  padding-block: 3px;
  border-radius: 6px;
  background-color: #eef1f8;
  border: solid 1px #a8a8a8;
  .item {
    flex: 1;
    cursor: pointer;
    .text {
      padding-top: 6px;
      padding-bottom: 4px;
      margin-inline: 1px;
      font-size: 14px;
      font-weight: 700;
      letter-spacing: 0.06em;
      line-height: 1em;
      border-radius: 4px;
      text-align: center;
      user-select: none;
    }
    &[data-selected=true] {
      .text {
        position: relative;
        color: #fff;
        background-color: #1d54af;
        text-shadow: 0px 1px 2px #030f88;
        &:is([data-arrow="true"] *) {
          &::after {
            position: absolute;
            top: -14px;
            left: 50%;
            margin-left: -10px;
            width: 20px;
            height: 14px;
            background-color: #1d54af;
            clip-path: polygon(50% 0, 100% 100%, 0 100%);
            content: '';
          }
        }
      }
    }
    &:not(:last-child) {
      border-right: solid 1px rgb(0 0 0 / .1);
    }
  }
  &[data-type="round"] {
    border-radius: 90px;
    .item {
      .text {
        border-radius: 12px;
      }
    }
  }
  @media screen and (min-width: 830px) {
    .item {
      transition: color .2s ease-in-out;
      &:hover {
        color: #438fec;
      }
    }
  }
}
</style>
